'use strict';

import jQuery from 'jquery';

const COMPONENT_ATTR = 'data-search-map-notification';
const COMPONENT_SELECTOR = `[${COMPONENT_ATTR}]`;

const IS_VISIBLE_CLASS = 'is-visible';

const EVENT_SEARCH_MAP_NOTIFICATION = 'event-search-map-notification';

const $window = jQuery(window);

export default class SearchMapNotification {

    constructor(element) {
        const component = this;

        component.$element = jQuery(element);

        $window.on(EVENT_SEARCH_MAP_NOTIFICATION, (event, data) => {
            component.$element.addClass(data.type);
            component.$element.html(data.message);

            component.$element.addClass(IS_VISIBLE_CLASS).delay(5000).queue(() => {
                component.$element.removeClass(IS_VISIBLE_CLASS).dequeue;
            });
        });
    }

}

jQuery(COMPONENT_SELECTOR).each((index, element) => new SearchMapNotification(element));
